import qz from "qz-tray";
import { toast } from "sonner";
import { api } from "@/lib/api";

let ready = false;
let connecting = null;
function setup() {
  if (ready) return;
  ready = true;
  qz.security.setCertificatePromise((resolve, reject) => api.get("/print/certificate", { responseType: "text", transformResponse: (d) => d }).then((r) => resolve(r.data)).catch(reject));
  qz.security.setSignatureAlgorithm("SHA512");
  qz.security.setSignaturePromise((toSign) => (resolve, reject) => api.post("/print/sign", { request: toSign }).then((r) => resolve(r.data.signature)).catch(reject));
}

export const qzActive = () => qz.websocket.isActive();

export async function qzConnect() {
  setup();
  if (qz.websocket.isActive()) return true;
  connecting ||= qz.websocket.connect({ retries: 0, delay: 0 }).then(() => true, () => false).finally(() => { connecting = null; });
  return connecting;
}

export async function qzPrinters() {
  return (await qzConnect()) ? qz.printers.find() : null;
}

const loadImg = (src) => new Promise((res, rej) => { const i = new Image(); i.crossOrigin = "anonymous"; i.onload = () => res(i); i.onerror = rej; i.src = src; });

async function resizeLogo({ _width, ...item }) {
  try {
    const img = await loadImg(item.data);
    const h = Math.max(1, Math.round((img.naturalHeight * _width) / img.naturalWidth));
    const c = document.createElement("canvas");
    c.width = _width; c.height = h;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "#fff"; ctx.fillRect(0, 0, _width, h);
    ctx.drawImage(img, 0, 0, _width, h);
    return { ...item, flavor: "base64", data: c.toDataURL("image/png").split(",")[1] };
  } catch {
    return item;
  }
}

export async function qzPrint(printer, data) {
  if (!(await qzConnect())) throw new Error("QZ Tray não encontrado");
  const prepared = await Promise.all(data.map((x) => (x && x._width ? resizeLogo(x) : x)));
  await qz.print(qz.configs.create(printer), prepared);
}

export function printerFor(settings, route) {
  const p = settings?.printing || {};
  if (!p.enabled) return null;
  return (p.printers || []).find((x) => x.id === p.routes?.[route]) || null;
}

export const copiesFor = (settings, route) => {
  const n = settings?.printing?.copies?.[route];
  return n === undefined || n === null ? 1 : Number(n);
};

export const repeat = (data, n) => Array.from({ length: n }, () => data).flat();

export async function directPrint(session, route, build) {
  const copies = copiesFor(session.tenant.settings, route);
  if (copies === 0) return true;
  const printer = printerFor(session.tenant.settings, route);
  if (!printer) return false;
  try {
    await qzPrint(printer.name, repeat(build(printer), copies));
    return true;
  } catch {
    toast.error(`Impressão direta falhou em ${printer.name}. Verifique o QZ Tray.`);
    return false;
  }
}
